import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  profile: {
    width: 100,
    height: 100,
    d: `M70,62.32c-5-1.5-8.33-4.23-9.16-9A25.89,25.89,0,0,0,68,39.07a5.14,5.14,0,0,0,2.08-3.84c.26-1.88-.16-3.55-1-4.28,
    1.09-2.38,1.74-9.42.68-13.51C68.22,11.22,62,7.5,59.85,7.12a5.6,5.6,0,0,0-3.08.43c-.36.3-.63.59-1,.31C49.34,3,34.41,
    10,31.64,15.94a25.31,25.31,0,0,0-1.35,14.91c-.89.66-1.37,2.41-1.1,4.38.33,2.3,1.56,4,2.8,4a25.81,25.81,0,0,0,7.17,
    14.14c-.66,4.64-3.37,7.13-9.16,9C18.88,65.43,10.4,70,10.4,77.93c0,1.89,1.49,8.91,1.69,10.12,1.89,5.15,74.06,5,75.41,0,
    .19-1.17,2.1-7.8,2.1-10.12C89.6,69.89,82,65.91,70,62.32Z`,
  },
});
